<template>
  <!--  查看路线-->
  <div class="getStoreLocation">
    <div id="container" class="hHP wHP" />
  </div>
</template>

<script>
export default {
  name: "GetStoreLocation",
  props: {
    deliveryId: {
      type: [String, Object, Array],
      default: "",
    },
  },
  data() {
    return {
      locationRide: {},
      locationTar: {},
      distance: null,
      status: null
    };
  },
  mounted() {
    this.getDeliveryInfo(this.deliveryId);
  },
  methods: {
    getDeliveryInfo(id) {
      this.topsAjax.get(`${this.baseUrls.ordDelivery}/location/` + id).then((res) => {
        this.locationRide = res.locationRide;
        this.locationTar = res.locationTar;
        this.distance = res.distance
        this.status = res.status
        this.getStoreLocation();
      });
    },
    getStoreLocation() {
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 15,
        center: [this.locationRide.longitude, this.locationRide.latitude],
      });
      var marker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [this.locationTar.longitude, this.locationTar.latitude],
        anchor: "bottom-center",
      });
      var position = [this.locationRide.longitude, this.locationRide.latitude];

      let tarLocation = '顾客'
      if (this.status === 3 || this.status === 4) {
        tarLocation = '商家'
      }
      //构建自定义信息窗体
      var infoWindow = new AMap.InfoWindow({
        anchor: "top-left",
        content: `骑手距离${tarLocation}：${this.distance/1000}公里`,
      });
      infoWindow.open(map, position);
      new AMap.Marker({ position: position, map });
      map.add(marker);
      // map.setFitView();
      this.topsAjax.get(`${this.baseUrls.ordDelivery}/location/sync`, { deliveryId: this.deliveryId });
    },
  },
};
</script>

<style lang="scss">
.getStoreLocation {
  height: 400px;
}
</style>
